import styled from 'styled-components';
import { ReactComponent as Icon } from './HeartOutline.svg';

export const HeartOutline = styled(Icon)`
  fill: currentColor;
  width: 100%;
  height: 100%;
`;
